import { Environment } from '@digital-platform/rs-shared/domain';
import { auth0ProdTenantConfig } from './auth0-tenant.config';

export const environment: Environment = {
  production: true,
  trackjsToken: '258f9f87a3da4ccfb0cb10f1821c5ce8',
  adobeConfig: [
    // WebSDK
    {
      profile: '203080de9325',
      key: 'f76fbcc4465e',
    },
    // App Measurement
    // {
    //   profile: '50594d21a9d8',
    //   key: 'a49fb210829b',
    // },
  ],

  // Proxies via CloudFront to the configured ClassicNginx host
  classicUiHost: '/',
  coveoClientId: 'republicservices7axnrz9o',
  coveoEndpoint: 'https://republicservices7axnrz9o.org.coveo.com',
  appSwitcherRootUrl: 'https://www.republicservices.com',
  appSwitcherPortals: {
    apps: {
      dashboard: '/app-switcher',
    },
    rscom: {
      dashboard: '/account/dashboard',
      signUp: '/signup/recycling-waste',
    },
    cor1: {
      dashboard: 'https://cor.republicservices.com',
      signUp: '/signup/cor1',
    },
    cor2: {
      dashboard: 'https://cor2.republicservices.com',
      signUp: '/signup/cor2',
    },
    sw: {
      dashboard: 'https://account.republicservices.com',
      signUp: '/app-switcher/special-waste-signup-instruction',
    },
    na: {
      dashboard: 'https://secure.myrepublicaccount.com',
      signUp: '/', // No sign up for national accounts
    },
    profile: {
      dashboard: '/profile',
    },
    boa: {
      dashboard: '/profiling',
    },
  },
  tenantConfig: auth0ProdTenantConfig,
  paymentFormEndpoint:
    'https://payment.republicservices.com/payment-form-element',
};
